import { STUDY_TOOLS_NOTES_ROUTES } from '../shared/utils/routes'
import createAppRouter from './create_router'

const studyToolsNotesRouter = createAppRouter(STUDY_TOOLS_NOTES_ROUTES, {
  redirect: true,
  history: true,
})

export default studyToolsNotesRouter
